export { default } from './List';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/List/index.js
// module id = 332
// module chunks = 0